"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForRedirection = exports.createModlServices = void 0;
var modl_interpreter_1 = require("modl-interpreter");
var exceptions_1 = require("./exceptions");
exports.createModlServices = function () { return new ModlServicesImpl(); };
exports.checkForRedirection = function (obj) {
    if (typeof obj === 'object') {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if ('@R' === key) {
                    var value = obj[key];
                    if (typeof value === 'string') {
                        throw new exceptions_1.NumLookupRedirect(value);
                    }
                }
                exports.checkForRedirection(obj[key]);
            }
        }
    }
};
var ModlServicesImpl = (function () {
    function ModlServicesImpl() {
    }
    ModlServicesImpl.prototype.interpretNumRecord = function (modl) {
        var jsonObj = modl_interpreter_1.interpreter.interpretToJsonObject(modl);
        if (jsonObj) {
            exports.checkForRedirection(jsonObj);
            return jsonObj;
        }
        return {};
    };
    return ModlServicesImpl;
}());
//# sourceMappingURL=modlservices.js.map